import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import caution from "../../../assets/images/caution.png";
import getSsn from "../../common/Ssn";

class SSNRiskReport extends Component {
  constructor(props) {
    super(props);

    const records = _.get(
      this.props.reportData,
      "personReport.person[0].SSNInfos[0].SSNInfo"
    );
    this.state = {
      records,
      activeIndex: 0,
    };
  }
  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const rows = [];
    if (this.state.records !== undefined && this.state.records.length > 0) {
      const ssns = [];
      _.forEach(this.state.records, (r) => {
        if (_.get(r, "SSNRisk[0]._") !== undefined) ssns.push(r);
      });
      if (ssns !== undefined && ssns.length > 0) {
        _.forEach(ssns, (record, index) => {
          if (index === 0) {
            const SSN = _.get(record, "SSN[0]._", "");
            const Issued = _.get(record, "SSNYears[0]._", "");
            const Risk = _.get(record, "SSNRisk[0]._", "");
            const state = _.get(record, "SSNState[0]._", "");

            // rows.push(
            //   <Table.Row
            //     key={`Person_Name_Sens`}
            //     className={"report-section-header"}
            //   >
            //     <Table.Cell
            //       className="icon-align-middle text-center"
            //       colSpan={3}
            //     >
            //       Sensitive Information
            //     </Table.Cell>
            //   </Table.Row>
            // );
            rows.push(
              <Table.Row key={`rep_crim_row_1_${index}`}>
                {index === 0 && (
                  <Table.Cell
                    rowSpan={ssns.length - 1}
                    className="report-sub-sub-section-header text-center border-right"
                  >
                    SSN Risk Information
                  </Table.Cell>
                )}
                <Table.Cell className={"border-right"}>
                  <span className="text-bold"> SSN: </span>{" "}
                  {getSsn(SSN, this.props)} <br />{" "}
                  {Risk && <img alt="caution" src={caution} />}
                  {Risk}
                </Table.Cell>
                <Table.Cell>
                  <span className="text-bold">ISSUED:</span>
                  {Issued} &nbsp; in &nbsp; {state}
                </Table.Cell>
              </Table.Row>
            );
          }
        });
      }
    }
    return rows;
  }
}

export default SSNRiskReport;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/SSNRiskReport.js